export default "__VITE_ASSET__CCOpDjhj__"